module.exports = __webpack_public_path__ + "static/media/AnlookImage.dc4ea997.png";